import BasePage from "../modules/basePage";
import adherenceSingleVideo from "../modules/adAdherence/adherenceSingleVideo";
import "../../css/pages/adAdherence.scss";

class adAdherencePage extends BasePage {
    constructor(...opts) {
        super(...opts);
    }

    init() {
        super.init();
    }

    onReady() {
        super.onReady();
        new adherenceSingleVideo();
    }
}

new adAdherencePage();
